<template>
  <ItemPage
    :title="title"
    size="md"
    :actions="actions"
  >
    <template>
      <v-text-field
        v-model="feedbackReport.author.full_name"
        label="Usuário autor"
        outlined
        readonly
      />
      <v-text-field
        v-model="feedbackReport.author.id"
        label="ID do usuário autor"
        outlined
        readonly
      />
      <v-text-field
        v-model="authorType"
        label="Usuário autor tipo"
        outlined
        readonly
      />

      <v-text-field
        v-model="feedbackReport.institution.code"
        label="Código da instituição"
        outlined
        readonly
      />
      <v-text-field
        v-model="feedbackReport.institution.name"
        label="Nome da instituição"
        outlined
        readonly
      />
      <v-text-field
        v-model="feedbackReport.page_url"
        label="URL onde foi feito o feedback"
        outlined
        readonly
      />
      <v-text-field
        v-model="feedbackReport.route_name"
        label="Rota onde foi feito o feedback"
        outlined
        readonly
      />
      <v-text-field
        v-model="feedbackReport.status"
        label="Status"
        outlined
        readonly
      />
      <v-text-field
        v-model="feedbackReport.category"
        label="Tipo de Report"
        outlined
        readonly
      />
      <v-text-field
        v-model="feedbackReport.title"
        label="Nome"
        outlined
        readonly
      />
      <v-textarea
        v-model="feedbackReport.description"
        counter
        label="Descrição"
        placeholder="Descrição"
        outlined
        readonly
      />
      <v-data-table
        :headers="headers"
        :items="comments"
        :items-per-page="15"
        hide-default-footer
        item-key="id"
      >
        <template #item.author="{ item }">
          {{ item.author.name }} - {{ item.author.id }}
        </template>
        <template #item.comment="{ item }">
          {{ item.comment }}
        </template>
        <template #item.created_at="{ item }">
          {{ dayjs(item.created_at).fromNow() }}
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        :length="totalPages"
        :total-visible="5"
        class="mt-4"
      />
    </template>
  </ItemPage>
</template>

<script>
import ItemPage from '@/components/pages/ItemPage.vue'

import handlesServerValidation from '@/mixins/handles-server-validation.js'
import UpdateReportDialog from './UpdateReportDialog.vue'
import NewCommentReportDialog from './NewCommentReportDialog.vue'
import { getTextForDisplay as getRoleName } from '@/enums/roleTypes'
import dayjs from '@/dayjs'

export default {
  components: {
    ItemPage
  },

  mixins: [
    handlesServerValidation
  ],

  data () {
    return {
      title: 'Feedback Report',
      feedbackReport: null,
      loading: false,
      loadingMsg: '',
      comments: [],

      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'author'
        },
        {
          text: 'Comentário',
          align: 'start',
          value: 'comment'
        },
        {
          text: 'Feito',
          align: 'start',
          value: 'created_at'
        }
      ],

      // Pagination
      page: 1,
      totalPages: 1
    }
  },

  computed: {
    actions () {
      return [
        {
          label: 'Atualizar Status do Report',
          action: this.openUpdateReport,
          icon: 'mdi-update',
          disabled: false
        },
        {
          label: 'Adicionar Comentario',
          action: this.openNewCommentReport,
          icon: 'mdi-plus',
          disabled: false
        }
      ]
    },
    authorType () {
      return getRoleName(this.feedbackReport.author.type)
    },

    reportId () {
      return this.$route.params.id
    }
  },
  async mounted () {
    await this.getFeedbackReport()
    await this.getFeedbackReportComments()
  },
  methods: {
    async getFeedbackReport () {
      try {
        this.feedbackReport = await this.$api.getFeedbackReport(this.reportId)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter o relatório de feedback, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },
    async getFeedbackReportComments () {
      try {
        const content = await this.$api.getFeedbackReportComments(this.reportId)
        this.comments = content.data
        this.totalPages = content.meta.last_page
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter o relatório de feedback, tente novamente mais tarde.', color: 'red' })
        this.getErrors(e)
      }
    },

    async openUpdateReport () {
      await this.$dialog.custom(UpdateReportDialog).with({ report: this.feedbackReport }).show()
        .then(async (update) => {
          if (!update) {
            return
          }
          await this.getFeedbackReport()
        })
    },
    async openNewCommentReport () {
      await this.$dialog.custom(NewCommentReportDialog).with({ report: this.feedbackReport }).show()
        .then(async (newComment) => {
          if (!newComment) {
            return
          }
          await this.getFeedbackReportComments()
        })
    },
    dayjs
  }
}
</script>
